import React from 'react';

const panelStyle: React.CSSProperties = {
  border: '1px solid #e5e7eb',
  borderRadius: 12,
  background: '#ffffff',
  padding: 16,
};

export default function PlatformSecurityCenter() {
  return (
    <main style={{ fontFamily: 'Inter, sans-serif', padding: 24, maxWidth: 980 }}>
      <h1 style={{ marginBottom: 8 }}>Platform Security Hardening</h1>
      <p style={{ color: '#4b5563', marginBottom: 16 }}>
        This is the platform security surface for `admin.bassitai.com`. Tenant-facing security controls are not rendered here.
      </p>
      <section style={panelStyle}>
        <h2 style={{ marginTop: 0 }}>Current scope</h2>
        <ul style={{ marginBottom: 0 }}>
          <li>Infrastructure security policy visibility</li>
          <li>Control-plane access posture and MFA enforcement</li>
          <li>Audit and incident readiness indicators</li>
        </ul>
      </section>
    </main>
  );
}

